var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMesBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 267,
    viewBox: "0 0 440 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.105 67.5702C388.638 61.3435 395.876 57.6602 403.578 57.6602H439.464V266.977H238.93L384.105 67.5702Z",
    fill: "#2667B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.578125 266.977H169.346L272.836 117.674H121.049C113.328 117.674 106.075 121.376 101.544 127.628L0.578125 266.977Z",
    fill: "#2667B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8242 266.439H239.437L408.759 34.0096C418.906 20.0807 408.957 0.523438 391.724 0.523438H253.669L62.8242 266.439Z",
    fill: "#102B4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesBg);
export default __webpack_public_path__ + "static/media/mesBg.2a7530d7cbd03fd395b2be20372a6dc7.svg";
export { ForwardRef as ReactComponent };